import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import DbService from "../services/DbService";
import QuestionPopover from "./QuestionPopover";
import { PlacementQuestion } from "../types/PlacementQuestion";
import { PlacementTest, PlacementTestResult } from "../types/PlacementTest";

const PlacementTestList: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);

  const [placementTests, setPlacementTests] = useState<PlacementTest[]>([]);
  const hasFetchedRef = React.useRef(false);

  const columns: GridColDef[] = [
    { field: "firstName", headerName: "First Name", width: 150 },
    { field: "lastName", headerName: "Last Name", width: 150 },
    { field: "mobile", headerName: "Mobile", width: 120 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "promotionCode", headerName: "Promotion Code", width: 150 },
    {
      field: "startTime",
      headerName: "Start time",
      width: 150,
      renderCell: (params: GridRenderCellParams) => {
        if (!params.value) {
          return;
        }
        const formattedDateTime = getFormattedTime(params.value);
        return (
          <div
            style={{
              display: "flex",
              width: "100%",
            }}
          >
            <span>{formattedDateTime}</span>
          </div>
        );
      },
    },
    {
      field: "finishTime",
      headerName: "Completed time",
      width: 150,
      renderCell: (params: GridRenderCellParams) => {
        if (!params.value) {
          return;
        }
        const formattedDateTime = getFormattedTime(params.value);
        return (
          <div
            style={{
              display: "flex",
              width: "100%",
            }}
          >
            <span>{formattedDateTime}</span>
          </div>
        );
      },
    },
    {
      field: "duration",
      headerName: "Duration",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        // Retrieve the start and finish times from the row data
        const startTime = params.row.startTime;
        const finishTime = params.row.finishTime;

        if (!startTime || !finishTime) {
          return <span>-</span>;
        }

        // Calculate the difference in minutes
        const start = new Date(startTime).getTime();
        const finish = new Date(finishTime).getTime();
        const durationInMinutes = Math.round((finish - start) / 60000); // Divide by 60000 to convert milliseconds to minutes

        return (
          <div
            style={{ display: "flex", width: "100%", justifyContent: "center" }}
          >
            <span>{durationInMinutes} minutes</span>
          </div>
        );
      },
    },
    {
      field: "questions",
      headerName: "Questions",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        const questions: PlacementQuestion[] = params.value || [];
        return <QuestionPopover questions={questions} />;
      },
    },
    {
      field: "results",
      headerName: "Result",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        const data = params.value as PlacementTestResult;
        if (!params.value) {
          return "";
        }
        return `Easy:${data.easyCorrect}, Hard:${data.hardCorrect} ->${data.programName}`;
      },
    },
  ];

  useEffect(() => {
    const fetchPlacementTests = async () => {
      setLoading(true);
      try {
        const response = await DbService.getPlacementTests();
        setPlacementTests(response.data);
      } catch (error) {
        console.error("Failed to fetch placementTests:", error);
      } finally {
        setLoading(false);
      }
    };
    if (!hasFetchedRef.current) {
      fetchPlacementTests();
      hasFetchedRef.current = true;
    }
  }, []);

  const getFormattedTime = (timestamp: number): string => {
    const date = new Date(timestamp);
    // Format the date with time up to minutes
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // Use 12-hour clock, set to false for 24-hour clock
    };
    return date.toLocaleDateString("en-AU", options);
  };

  return (
    <div style={{ height: 400, width: "100%" }}>
      <DataGrid
        rows={placementTests}
        columns={columns}
        loading={loading}
        getRowId={(row) => {
          return row._id;
        }}
        // More props as necessary...
      />
    </div>
    // <DynamicTableListTemplate<PlacementTest>
    //   columns={columns}
    //   data={placementTests}
    //   loading={loading}
    //   selectedRow={selectedPlacementTest}
    //   FormComponent={
    //     <PlacementQuestionForm
    //       selectedPlacementQuestion={selectedPlacementQuestion}
    //       onSubmit={handlePlacementQuestionSubmit}
    //     />
    //   }
    //   entityLabel="Placement Question"
    //   dialogTitle="Placement Question Form"
    //   onClearSelectedRow={handleCloseDialog}
    //   onConfirmDelete={handleDeletePlacementQuestionConfirm}
    //   entityToDelete={placementQuestionToDelete}
    // />
  );
};

export default PlacementTestList;
